export const fakeScheduleData = [
    {
        "pOfL": "Morning Meet with Mizanur Rahman Azhari",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 15
    },
    {
        "pOfL": "Dinner Meet with Shakib Al Hasan",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 14
    },
    {
        "pOfL": "Dinner Meet with Shahrukh Khan",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 13
    },
    {
        "pOfL": "Dinner Meet with Amitav ",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 12
    },
    {
        "pOfL": "Dinner Meet with Amitav ",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 11
    },
    {
        "pOfL": "Dinner Meet with Amitav ",
        banner: "https://superstarcommunicator.com/wp-content/uploads/2013/12/business-people-on-a-table.jpg",
        total: 10
    },
]